// auth
export const TOGGLE_SYSTEM_LOADING = "TOGGLE_SYSTEM_LOADING";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_MENU_LIST = "UPDATE_MENU_LIST";

export const USER_UPDATE_STATE = "USER_UPDATE_STATE";

export const SCORE_UPDATE_STATE = "SCORE_UPDATE_STATE";

export const TEMPLATE_UPDATE_STATE = "TEMPLATE_UPDATE_STATE";

export const BELONG_UPDATE_STATE = "BELONG_UPDATE_STATE";
export const STORELIST_UPDATE_STATE = "STORELIST_UPDATE_STATE";

export const COUNTRY_UPDATE_STATE = "COUNTRY_UPDATE_STATE";

export const PACKAGELIST_UPDATE_STATE = "PACKAGELIST_UPDATE_STATE";

export const ORDER_UPDATE_STATE = "ORDER_UPDATE_STATE";
export const PAYOUTS_UPDATE_STATE = "PAYOUTS_UPDATE_STATE";

export const RISK_UPDATE_STATE = "RISK_UPDATE_STATE";
